/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/ConditionalChildren", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Dropdown", "azure-devops-ui/FilterBar", "azure-devops-ui/TextFilterBarItem", "react", "../../Resources"], function (require, exports, ConditionalChildren_1, String_1, Dropdown_1, FilterBar_1, TextFilterBarItem_1, React, Resources) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /* Including from office-ui-fabric-react to avoid direct dependency on office-ui-fabric-react */
    var SelectionMode;
    (function (SelectionMode) {
        SelectionMode[SelectionMode["none"] = 0] = "none";
        SelectionMode[SelectionMode["single"] = 1] = "single";
        SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
    })(SelectionMode || (SelectionMode = {}));
    exports.NameKey = "nameKey";
    exports.TypeKey = "typeKey";
    var KubeFilterBar = /** @class */ (function (_super) {
        __extends(KubeFilterBar, _super);
        function KubeFilterBar() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        KubeFilterBar.prototype.render = function () {
            return (React.createElement(ConditionalChildren_1.ConditionalChildren, { renderChildren: this.props.filterToggled },
                React.createElement(FilterBar_1.FilterBar, { filter: this.props.filter, className: this.props.className || "" },
                    React.createElement(TextFilterBarItem_1.KeywordFilterBarItem, { filterItemKey: exports.NameKey, className: "keyword-search", placeholder: String_1.localeFormat(Resources.FindByNameText, this.props.keywordPlaceHolder) }),
                    React.createElement(Dropdown_1.DropdownFilterBarItem, { placeholder: this.props.pickListPlaceHolder, showPlaceholderAsLabel: true, filterItemKey: exports.TypeKey, selection: this.props.selection, noItemsText: Resources.NoItemsText, items: this.props.listItems })),
                this.props.addBottomPadding && React.createElement("div", { className: "page-content-top" })));
        };
        return KubeFilterBar;
    }(React.Component));
    exports.KubeFilterBar = KubeFilterBar;
});
